import { FactSample, StepSample } from '@/modules/analysis/models/analysisRequest';
import { SampleStatusEnum } from '@/modules/analysis/models/sampleStatusEnum';

/**
 * Sample status go through multiple steps
 *
 * 1 - RECEIVED
 * 2 - FINISHED
 *
 * A Sample status has to respect workflow order : All previous status has to be created fisrt(
 * Example : FINISHED cannot be created before RECEIVED)
 * A Sample status cannot be created multiple times
 * A Sample status cannot be deleted
 *
 * @param steps a 2 dimensionnal array wich contains all statuses of a sample received or not received in database
 * @param status the status to check the workflow in the steps array
 * @returns true if that workflow is correct, false otherwise.
 */
export function isValidSampleStatusWorkflow(steps: StepSample[][], status: string): boolean {
  if (status === Object.values(SampleStatusEnum)[0]) {
    return true;
  }
  for (const step of steps) {
    const falseCount = step.filter((item) => item.value === false).length;
    const containsTargetStatus = step.filter((item) => item.status === status).length > 0;
    if (falseCount > 0 && !containsTargetStatus) {
      return false; // workflow order not respected
    }
    for (const wStatus of step) {
      if (wStatus.status === status) {
        return true;
      }
    }
  }
  return false;
}

export function convertFactSampleArrayToStepSampleArray(facts: FactSample[]): StepSample[][] {
  const result: StepSample[][] = [
    [{ status: SampleStatusEnum.RECEIVED, value: false, isNew: true }],
    [{ status: SampleStatusEnum.FINISHED, value: false, isNew: true }]
  ];

  for (const step of result) {
    for (const status of step) {
      facts.forEach((fact) => {
        if (fact.status === status.status) {
          status.value = true;
          status.isNew = false;
        }
      });
    }
  }

  return result;
}

export function convertStepSampleArrayToFactSampleArray(steps: StepSample[][]): FactSample[] {
  const facts: FactSample[] = [];
  for (const step of steps) {
    for (const status of step) {
      if (status.isNew && status.value) {
        const fact: FactSample = { status: status.status };
        facts.push(fact);
      }
    }
  }
  return facts;
}

export function updateStepSampleArray(steps: StepSample[][], status: StepSample): void {
  for (const step of steps) {
    for (const wStatus of step) {
      if (wStatus.status === status.status) {
        wStatus.value = status.value;
        wStatus.isNew = status.isNew;
      }
    }
  }
}
